import React, { FC, useCallback, useState } from 'react';
import Draggable, { DraggableEventHandler } from 'react-draggable';

import { Button, ClosingOverlay, Label, Text, cn } from 'Modules/ui2';
import { WithT } from 'Modules/core/i18n';

import Warning from './warningBanner.sprite.svg';
import styles from './index.module.scss';


const FULL_HEIGHT = 292;
const CLOSE_DELTA = FULL_HEIGHT / 4;

type ErrorBannerProps = WithT & {
    onClose: () => void;
}

export const ErrorBanner: FC<ErrorBannerProps> = ({ t, onClose }) => {
    const [height, setHeight] = useState<number>(292);
    const handleDrag = useCallback<DraggableEventHandler>(
        (e, data) => setHeight(height => height - data.deltaY),
        [],
    );
    const handleStop = useCallback<DraggableEventHandler>(
        () => {
            const needClose = Math.abs(FULL_HEIGHT - height) > CLOSE_DELTA;
            if (needClose)
                onClose();
            else
                setHeight(FULL_HEIGHT);
        },
        [height, setHeight, onClose],
    );
    return (
        <Draggable
            axis='y'
            defaultClassName={styles.container}
            defaultClassNameDragging={styles.dragHandleActive}
            onDrag={handleDrag}
            onStop={handleStop}
            bounds={{
                top: 0,
            }}
            // @ts-ignore
            position={{ y: 0 }}
            cancel='button'
        >
            <div className={styles.content} style={{ height }}>
                <div className={cn(styles.handle, 'hcenter')} />
                <div className={styles.header}>
                    <Label component='div' textSize='24' weight='demibold'>
                        {t('rate.error.header')}
                    </Label>
                    <Warning />
                </div>
                <Text component='div' textSize='18'>
                    {t('rate.error.description')}
                </Text>
                <Button
                    variant='normal'
                    size='56'
                    onClick={onClose}
                    className='.button'
                >
                    {t('rate.error.button')}
                </Button>
                <ClosingOverlay
                    zIndex={41}
                    onClose={onClose}
                    darken
                />
            </div>
        </Draggable>
    );
};
